import axios from 'axios';
import { apiEndpoint } from '@/enums/generic';

const { businessEntitiesUrl, root } = apiEndpoint;

export const getBusinessEntityById = async (businessEntityId) => {
  if (!businessEntityId || typeof businessEntityId !== 'string') {
    throw new Error(`No valid ID was provided: ${businessEntityId}`);
  }
  return axios({
    method: 'GET',
    url: `${businessEntitiesUrl}/${businessEntityId}`,
  }).catch(function (error) {
    return error.response;
  });
};

export const putBusinessEntity = async (businessEntity, workTypeCode) => {
  let url = `${businessEntitiesUrl}/${businessEntity.id}`;
  if (workTypeCode) url += `?workTypeCode=${workTypeCode}`;

  return axios.put(url, businessEntity, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const putRawBusinessEntity = async (businessEntity) => {
  return axios.post(
    `${businessEntitiesUrl}/${businessEntity.id}/backup`,
    businessEntity,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getAllBusinessEntities = async () => {
  return axios.get(businessEntitiesUrl);
};

export const getBusinessEntityUpdatedAt = async (businessEntityId) => {
  if (!businessEntityId || typeof businessEntityId !== 'string') {
    throw new Error(`No valid ID was provided: ${businessEntityId}`);
  }
  const resp = await axios({
    method: 'GET',
    url: `${businessEntitiesUrl}/${businessEntityId}`,
  });
  return resp.data?.updatedAt;
};

export const getBackupsByPropertyId = async (propertyId) => {
  return axios.get(`${root}/management/history/${propertyId}/versions`);
};

export const getBackupVersion = async (propertyId, version) => {
  return axios.get(
    `${root}/management/history/${propertyId}?version=${version}`
  );
};
